export default __webpack_public_path__ + "static/media/icecream.0c41e280.svg";